import { Immutable } from "immer";
import React, { type JSX } from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { IMenuSnippetLinkWithImage } from "../../utils/menu.interface";

import styles from "./index.module.scss";

// CMS badge position choice -> module class. Unknown values get no
// position class, as the unstyled `--${position}` literal did before.
const badgePositionClasses: Readonly<Record<string, string>> = {
    "top-left": styles.menuDropdownBadgeTopLeft,
    "top-right": styles.menuDropdownBadgeTopRight,
    "bottom-left": styles.menuDropdownBadgeBottomLeft,
    "bottom-right": styles.menuDropdownBadgeBottomRight,
};

type IProps = Immutable<{
    linksArray: readonly IMenuSnippetLinkWithImage[];
    linkID: number;
}>;

export const DropdownLinks = ({
    linksArray,
    linkID,
}: IProps): React.ReactNode => {
    const dropdownLinks = linksArray.map((obj, id) => {
        let badge: JSX.Element | null = null;
        if (obj.value.badge) {
            badge = (
                <span>
                    <span
                        className={concatClassNames([
                            styles.menuDropdownBadge,
                            styles.menuDropdownBadgeMobile,
                        ])}
                    >
                        {obj.value.badge.mobile_text}
                    </span>
                    <img
                        className={concatClassNames([
                            styles.menuDropdownBadge,
                            badgePositionClasses[obj.value.badge.position],
                        ])}
                        src={obj.value.badge.image.url}
                        alt={obj.value.badge.mobile_text}
                    />
                </span>
            );
        }

        const blockClasses = concatClassNames([
            styles.menuDropdownBlock,
            `menu-dropdown-block--${id}`,
        ]);

        return (
            <a
                title={obj.value.image.title}
                key={id}
                href={obj.value.page.url}
                className={blockClasses}
                style={{ backgroundImage: `url('${obj.value.image.url}')` }}
            >
                {obj.value.override_title}
                {badge}
            </a>
        );
    });

    return (
        <div className={styles.mainDropdownMenuShopLinks} key={linkID}>
            {dropdownLinks}
        </div>
    );
};
